export default "__VITE_ASSET__C2yvOq6G__"